import LeaderboardTopImg from "../../assets/images/png/leaderboardTopImage.png";
import DailyQuestionIcon from "../../assets/images/webp/DailyQuestionIcon.webp";
import ReferralIcon from "../../assets/images/webp/Referralicon.webp";
import CompleteWorkoutIcon from "../../assets/images/webp/completeWorkoutIcon.webp";
import ShareIcon from "../../assets/images/webp/shareIcon.webp";
import AchievementIcon from "../../assets/images/webp/achievementIcon.webp";
import MilestonesIcon from "../../assets/images/png/milestones.png";
import omniCoins from "../../assets/images/webp/overviewPage/omniCoinImg.webp";
import TopClientTwo from "../../assets/images/png/topClientTwo.png";
import TopClientsOne from "../../assets/images/png/topClientOne.png";

import VerticalGap from "../../components/VerticalGap";
import LeaderBar from "../../components/LeaderBar";

import "./index.scss";

const Leaderboard = () => (
  <div className="leaderboard-section">
    <div className="leader-top">
      <div className="sub-heading">Climb the</div>
      <div className="heading">leaderboard</div>
      <VerticalGap />
      <div className="para">
        Where will you finish? Earn Omni-Coins by completing daily challenges, rewarding you for each step you take
        toward reaching your fitness goals. Each month, you will be entered to win prizes based on your placing on the
        leaderboard. The best part? The leaderboard resets each month, allowing you a fresh start to qualify for more
        prizes!
      </div>
      <div className="leaderboard-img">
        <img className="leader-image" src={LeaderboardTopImg} alt="leaderboard image" />
      </div>
      <VerticalGap />
      <div className="line">Stack up your Omni-Coins</div>
    </div>
    <div className="leader-vertical-middle">
      <div className="leader-left">
        <LeaderBar
          img={DailyQuestionIcon}
          title="Daily questions"
          description="Test your knowledge of fitness and health related topics, earning coins for correct answers. After all, knowledge is power."
        />
        <LeaderBar
          img={ReferralIcon}
          title="Referals for the app"
          description="Have your friends join in on the fun and get rewarded with coins along the way, helping you climb the leaderboard."
        />
      </div>
      <div className="leader-middle">
        <img className="image" src={omniCoins} alt="leaderboard icon" />
      </div>
      <div className="leader-right">
        <LeaderBar
          img={CompleteWorkoutIcon}
          title="Completing workouts"
          description="Earn coins for each workout you complete, whether it's in-person, virtual, or simply following your online program in the app."
        />
        <LeaderBar
          img={ShareIcon}
          title="Sharing on social media "
          description="Sharing your experience on social media provides both coins and social accountability. Let you friends see your hard work so they can cheer you on!"
        />
      </div>
    </div>
    <div className="leader-bottom">
      <div className="leader-bar">
        <LeaderBar
          img={AchievementIcon}
          title="Achieving milestones"
          description="Milestones are an easy way to earn coins. Push yourself, utilizing the app to it's fullest to earn each milestone."
        />
      </div>
      <div className="milestones-img">
        <img className="image" src={MilestonesIcon} alt="" />
      </div>
      <div className="leaderboard-positions">
        <div className="left-section">
          <div className="title">Climb the leaderboard for exciting prizes</div>
        </div>
      </div>
      <div className="client-positions">
        <img className="image bottom" src={TopClientsOne} alt="" />
        <img className="image top" src={TopClientTwo} alt="" />
      </div>
      <div className="win-text">
        <div className="title">
          Drawings held each month in our{" "}
          <a href="https://www.facebook.com/groups/4615103925255784" target="_blank">
            Facebook Group
          </a>
        </div>
        <div className="details">
          Clients will be divided into tiers based on your ranking for the month. The closer to the top of the
          leaderboard you finish, the better prize you will be entered to win.
        </div>
      </div>
    </div>
  </div>
);

export default Leaderboard;
